import {
   Component,
   EventEmitter,
   Input,
   OnInit,
   OnChanges,
   Output,
   SimpleChanges
} from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { NgxCurrencyDirective } from 'ngx-currency'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ButtonComponent } from '@appShared/components/button/button.component'
import { CommonService } from '@appShared/services/common.service'
import { StockService } from '@appShared/services/stock.service'
import { IStock } from '@appShared/interfaces/[Model-based]/stock.interface'

@Component({
   selector: 'app-stock-edit',
   templateUrl: './stock-edit.component.html',
   imports: [
      ReactiveFormsModule,
      NgxCurrencyDirective,
      ButtonComponent
   ]
})
export class StockEditComponent implements OnInit, OnChanges {
   @Input() stock: IStock
   @Output() stockUpdated = new EventEmitter();

   selectedStock: IStock
   isLoading: boolean

   /* form/form-fields */
   stockForm: FormGroup
   statedShareValue: FormControl
   statedValueNote: FormControl
   dividendPerShare: FormControl
   dividendNote: FormControl
   mouseoverStockSubmit: boolean
   isSubmitting: boolean

   constructor(
      private _stockService: StockService,
      private _commonService: CommonService,
      private _activeModal: NgbActiveModal
   ) {
      this._createFormGroup()
   }

   ngOnInit(): void {
      this.isLoading = true
   }

   ngOnChanges(changes: SimpleChanges): void {
      let stock = changes?.['stock']?.currentValue
      if (stock) {
         this._setStockData(stock)
      }
   }

   /*
   * private methods
   * */

   private _createFormGroup(): void {
      this.statedShareValue = new FormControl(null, Validators.required)
      this.statedValueNote = new FormControl(null)
      this.dividendPerShare = new FormControl(null, Validators.required)
      this.dividendNote = new FormControl(null)

      this.stockForm = new FormGroup({
         statedShareValue: this.statedShareValue,
         statedValueNote: this.statedValueNote,
         dividendPerShare: this.dividendPerShare,
         dividendNote: this.dividendNote
      })
   }

   private _setStockData(selectedStock: IStock): void {
      const setNumber = this._commonService.setNumber

      this.stockForm.patchValue({
         statedShareValue: setNumber(selectedStock.statedShareValue),
         statedValueNote: selectedStock.statedValueNote,
         dividendPerShare: setNumber(selectedStock.dividendPerShare),
         dividendNote: selectedStock.dividendNote
      })

      this.selectedStock = selectedStock
   }

   /*
    * public methods
    * */

   saveStock(): void {
      this.isSubmitting = true

      const stockFormValues = this.stockForm.value
      const updatedStock = {
         ...this.selectedStock,
         statedShareValue: stockFormValues.statedShareValue,
         statedValueNote: stockFormValues.statedValueNote,
         dividendPerShare: stockFormValues.dividendPerShare,
         dividendNote: stockFormValues.dividendNote
      } as IStock

      this._stockService
         .createUpdateStock(updatedStock)
         .then(shareholder => {
            const msgSuffix = updatedStock.id ? 'updated' : 'created'
            this._commonService.messageUser(`Stock Pricing ${msgSuffix}!`)

            this.stockUpdated.emit()

            this._activeModal.close()
         })
         .catch(() => {
            /* Do Nothing */
         })
         .finally(() => setTimeout(() => (this.isSubmitting = false), 500))
   }
}
